(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-card-hotspot"] && !Shopify.designMode) return;
  try {
    (() => {
    const hotspotControllers = window.__productCardHotspotControllers || new WeakMap();
    window.__productCardHotspotControllers = hotspotControllers;

    const parentControllers = window.__productCardHotspotParentControllers || new WeakMap();
    window.__productCardHotspotParentControllers = parentControllers;

    class ProductCardHotspotController {
      constructor(element) {
        this.element = element;
        this.wrapperItem = element.querySelector('.item-hotspot__wrapper');
        this.parentElement = this.resolveParentElement();
      }

      resolveParentElement() {
        return (
          this.element.closest('.block-column') ||
          this.element.closest('.block-row') ||
          this.element.closest('.shopify-section')
        );
      }

      init() {
        if (!this.wrapperItem || !this.parentElement) return;
        this.wrapperItem.style.transition = 'transform 0.1s linear';
        this.wrapperItem.style.willChange = 'transform';
        this.wrapperItem.style.transform = 'translate(0px, 0px)';
      }
    }

    class ParentHotspotController {
      constructor(parentElement) {
        this.parentElement = parentElement;
        this.items = [];
        this.currentMouseX = 0;
        this.currentMouseY = 0;
        this.targetMouseX = 0;
        this.targetMouseY = 0;
        this.isPointerInside = false;
        this.animationFrameId = null;
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.animate = this.animate.bind(this);
      }

      init() {
        this.refreshItems();
        this.parentElement.addEventListener('mousemove', this.handleMouseMove);
        this.parentElement.addEventListener('mouseleave', this.handleMouseLeave);
      }

      refreshItems() {
        this.items = Array.from(
          this.parentElement.querySelectorAll('.product-card-hotspot .item-hotspot__wrapper')
        );
      }

      handleMouseMove(event) {
        if (this.items.length === 0) return;

        const rect = this.parentElement.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;

        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        this.targetMouseX = (event.clientX - centerX) / (rect.width / 2);
        this.targetMouseY = (event.clientY - centerY) / (rect.height / 2);
        this.isPointerInside = true;

        if (!this.animationFrameId) {
          this.animationFrameId = requestAnimationFrame(this.animate);
        }
      }

      handleMouseLeave() {
        this.isPointerInside = false;
        this.targetMouseX = 0;
        this.targetMouseY = 0;

        if (!this.animationFrameId) {
          this.animationFrameId = requestAnimationFrame(this.animate);
        }
      }

      animate() {
        const ease = 0.12;
        this.currentMouseX += (this.targetMouseX - this.currentMouseX) * ease;
        this.currentMouseY += (this.targetMouseY - this.currentMouseY) * ease;

        const rect = this.parentElement.getBoundingClientRect();
        if (rect.width !== 0 && rect.height !== 0) {
          const baseIntensityX = Math.min(rect.width * 0.08, 100);
          const baseIntensityY = Math.min(rect.height * 0.04, 30);

          this.items.forEach((item, index) => {
            const itemIntensity = 1 + index * 0.15;
            const moveX = -(this.currentMouseX * itemIntensity * baseIntensityX);
            const moveY = -(this.currentMouseY * itemIntensity * baseIntensityY);
            const clampedX = Math.max(-baseIntensityX, Math.min(baseIntensityX, moveX));
            const clampedY = Math.max(-baseIntensityY, Math.min(baseIntensityY, moveY));

            item.style.transform = `translate(${clampedX}px, ${clampedY}px)`;
          });
        }

        const settledX = Math.abs(this.targetMouseX - this.currentMouseX) < 0.001;
        const settledY = Math.abs(this.targetMouseY - this.currentMouseY) < 0.001;

        if (!this.isPointerInside && settledX && settledY) {
          this.currentMouseX = 0;
          this.currentMouseY = 0;
          this.targetMouseX = 0;
          this.targetMouseY = 0;
          this.animationFrameId = null;
          return;
        }

        this.animationFrameId = requestAnimationFrame(this.animate);
      }
    }

    function ensureParentController(parentElement) {
      if (!parentElement) return null;

      let parentController = parentControllers.get(parentElement);
      if (!parentController) {
        parentController = new ParentHotspotController(parentElement);
        parentControllers.set(parentElement, parentController);
        parentController.init();
      } else {
        parentController.refreshItems();
      }

      return parentController;
    }

    function initHotspots(scope = document) {
      const hotspots = Array.from(scope.querySelectorAll('.product-card-hotspot'));
      hotspots.forEach((hotspot) => {
        let controller = hotspotControllers.get(hotspot);
        if (!controller) {
          controller = new ProductCardHotspotController(hotspot);
          hotspotControllers.set(hotspot, controller);
          controller.init();
        }

        ensureParentController(controller.parentElement);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHotspots());
    } else {
      initHotspots();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initHotspots(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      initHotspots(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["timeline-group"] && !Shopify.designMode) return;
  try {
    class TimelineGroup extends HTMLElement {
    constructor() {
      super();

      this.progressList = null;
      this.timelineItems = null;
      this.progressItems = [];
      this.lastClickedProgressItem = null;
      this.lastClickedTimelineItem = null;

      this.handleThemeEditorSectionLoad = this.handleThemeEditorSectionLoad.bind(this);
      this.handleThemeEditorBlockSelect = this.handleThemeEditorBlockSelect.bind(this);
    }

    connectedCallback() {
      this.cacheElements();
      if (this.isValid()) {
        this.init();
      }
      this.setupThemeEditorListeners();
    }

    disconnectedCallback() {
      this.removeThemeEditorListeners();
      this.progressItems = [];
      this.lastClickedProgressItem = null;
      this.lastClickedTimelineItem = null;
    }

    cacheElements() {
      this.progressList = this.querySelector('.timeline-progress-list');
      this.timelineItems = this.querySelectorAll('.timeline-item');
    }

    isValid() {
      return this.progressList && this.timelineItems?.length > 0;
    }

    init() {
      if (!this.isValid()) return;

      this.progressList.innerHTML = '';
      this.progressItems = [];

      Array.from(this.timelineItems).forEach((timelineItem, index) => {
        const progressItem = this.createProgressItem(timelineItem, index === 0);
        this.progressList.appendChild(progressItem);
        this.progressItems.push(progressItem);

        progressItem.addEventListener('click', () => {
          this.handleProgressItemClick(progressItem, timelineItem);
        });

        progressItem.addEventListener('mouseenter', () => {
          this.handleProgressItemHover(progressItem, timelineItem);
        });
      });

      if (this.timelineItems.length > 0) {
        this.timelineItems[0].classList.add('active');
        this.lastClickedProgressItem = this.progressItems[0];
        this.lastClickedTimelineItem = this.timelineItems[0];
      }
    }

    createProgressItem(timelineItem, isActive = false) {
      const label = timelineItem.getAttribute('data-timeline-label') || '';
      const timelineItemId = timelineItem.getAttribute('id');

      const progressItem = document.createElement('div');
      progressItem.className = 'progress-item';
      progressItem.setAttribute('data-timeline-item-id', timelineItemId);
      if (isActive) {
        progressItem.classList.add('active');
      }

      const labelSpan = document.createElement('span');
      labelSpan.className = 'progress-item-label subheading text-uppercase heading-color';
      labelSpan.textContent = label;

      const circleDiv = document.createElement('div');
      circleDiv.className = 'progress-item-circle';

      progressItem.appendChild(labelSpan);
      progressItem.appendChild(circleDiv);

      return progressItem;
    }

    handleProgressItemClick(progressItem, timelineItem) {
      this.deactivateAll();
      progressItem.classList.add('active');
      timelineItem.classList.add('active');
      this.lastClickedProgressItem = progressItem;
      this.lastClickedTimelineItem = timelineItem;
    }

    handleProgressItemHover(progressItem, timelineItem) {
      this.deactivateAll();
      progressItem.classList.add('active');
      timelineItem.classList.add('active');
      this.lastClickedProgressItem = progressItem;
      this.lastClickedTimelineItem = timelineItem;
    }

    deactivateAll() {
      this.progressItems.forEach(item => item.classList.remove('active'));
      Array.from(this.timelineItems).forEach(item => item.classList.remove('active'));
    }

    handleThemeEditorSectionLoad(event) {
      const timelineGroup = event.target.querySelector('timeline-group');
      if (timelineGroup === this) {
        this.cacheElements();
        if (this.isValid()) {
          this.init();
        }
      }
    }

    handleThemeEditorBlockSelect(event) {
      const timelineGroup = event.target.closest('timeline-group');
      if (timelineGroup === this) {
        this.cacheElements();
        if (this.isValid()) {
          this.init();
        }
      }
    }

    setupThemeEditorListeners() {
      document.addEventListener('shopify:section:load', this.handleThemeEditorSectionLoad);
      document.addEventListener('shopify:block:select', this.handleThemeEditorBlockSelect);
    }

    removeThemeEditorListeners() {
      document.removeEventListener('shopify:section:load', this.handleThemeEditorSectionLoad);
      document.removeEventListener('shopify:block:select', this.handleThemeEditorBlockSelect);
    }
  }

  if (!customElements.get('timeline-group')) {
    customElements.define('timeline-group', TimelineGroup);
  }
  } catch(e) { console.error(e); }
})();

})();
